import React from "react";

export const rawFields = ({ obj }) => {
  //renders raw fields of an object
  const elms = Object.keys(obj)
    .filter(
      key => {
          if (key.indexOf("_") === 0) {
              return false;
          }
          return !(key === "USAGE" || key === "LINK_FACSIMILE");
      }
    )
    .map(key => (
      <tr key={key}>
        <td>{key}</td>
        <td>
          {obj[key].map(value => (
            <span key={`${key}${value}`}>{value} &middot;</span>
          ))}
        </td>
      </tr>
    ));
  return (
    <table>
      <tbody>{elms}</tbody>
    </table>
  );
};

export function checkObjectOwner(obj, credentials) {
    return !!(credentials &&
        credentials.userpk &&
        obj._OWNER_PK &&
        obj._OWNER_PK.indexOf(credentials.userpk) > -1);

}